<template>
    <div class="checkmark-container">
        <label :for="checkboxId">{{label}}</label>
        <input type="checkbox" :id="checkboxId" :checked="value?'checked':''" @input="$emit('input', $event.target.checked)"/>
        <span class="checkmark" @click="changeState"></span>
        <a v-if="hint" :href="hint" target="_blank" class="hint">?</a>
    </div>
</template>

<script>
export default {
  name: "Checkmark",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    checkboxId: {
      type: String,
      required: true
    },
    hint: {
      type: String,
      required: false
    }
  },
  methods: {
    changeState() {
      var el = document.getElementById(this.checkboxId);
      el.checked = !el.checked;
      this.$emit("input", el.checked);
    }
  }
};
</script>

<style>
.checkmark-container {
  display: flex;
  flex-direction: row;
  width: calc(100% - 30px);
  align-items: center;
  position: relative;
  padding-right: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 1em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0.5em 0;
  box-sizing: content-box;
}

.checkmark-container a.hint{
    font-size: 0.8em;
    text-decoration: none;
    line-height: 1em;
    margin-bottom: 8px;
    margin-left: 5px;
}

#app .checkmark-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark-container input:focus + span {
  outline: 1px dotted #4a4f62;
  outline: -webkit-focus-ring-color auto 5px;
}

.checkmark {
  position: absolute;
  top: -1px;
  right: 0;
  height: 20px;
  width: 20px;
  background-color: #a1a7b9;
  transition: all .3s ease-in-out;
}

.checkmark-container:hover input ~ .checkmark {
  background-color: #666F8A;
}

.checkmark-container input:checked ~ .checkmark {
  background-color: #3D8FFF;
}

.checkmark:after {
  content: "";
  box-sizing: content-box;
  position: absolute;
  display: none;
}

.checkmark-container input:checked ~ .checkmark:after {
  display: block;
}

.checkmark-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/components/Checkmark.vue